import { useEffect, useState } from "react";

export function useLocalStorage(key, defaultValue) {
    // Читаем значение синхронно при инициализации
    const [value, setValue] = useState(() => {
        try {
            const raw = localStorage.getItem(key);
            if (raw === null) return defaultValue;
            return raw === "1";
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, value ? "1" : "0");
        } catch {
            // ignore
        }
    }, [key, value]);

    return [value, setValue];
}

export function getLocalStorage(key) {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}
